import * as React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";

export const PreviewLinkAndSVGSkeleton: React.FC = () => {
  return (
    <div className="bg-surface h-[200px] w-[200px] rounded-md">
      <Skeleton className="h-full w-full" />
    </div>
  );
};
